import React, {Component} from 'react';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {connect} from 'react-redux';
import ApiActions from 'go/actions/api';
import {PROFILE_INFORMATION_TITLE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {Container, Grid, Header} from 'semantic-ui-react';
import UserOrganizationRolesList from './userOrganizationRolesList';
import Profile from './profile';
import {API_PROFILE_PATCH_SUCCESS, API_PROFILE_PUT_SUCCESS} from 'common/types';
import {isProgramExternal} from 'common/utils';
import {isOnlyProgramExternal} from 'go/security/permissions';

export class ProfileContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: {
        firstName: '',
        lastName: '',
      },
      updateSuccess: null,
      showToast: false,
    };
  }

  submitUpdate = () => {
    this.props
      .patchUser(this.props.userId, JSON.stringify(this.state.profile), this.props.jwt)
      .then((res) => {
        this.setState({
          updateSuccess: res !== undefined && res.type === API_PROFILE_PATCH_SUCCESS,
          showToast: true,
        });
        setTimeout(() => {
          this.setState({updateSuccess: null, showToast: false});
        }, 10000);
      });
  };
  handleChange = (e, res) => {
    const {name, value} = res;
    this.setState({
      profile: {...this.state.profile, [name]: value},
      updateSuccess: null,
    });
  };

  componentDidMount() {
    document.title = PROFILE_INFORMATION_TITLE;
    this.props.getUser(this.props.userId).then((res) => {
      this.setState({profile: res.payload});
    });
  }

  render() {
    return (
      <React.Fragment>
        <Main>
          <Container>
            <Header as="h1"> Your Profile </Header>
            <Grid stackable>
              <Grid.Column width={7}>
                <Profile
                  updateSuccess={this.state.updateSuccess}
                  showToast={this.state.showToast}
                  profile={this.state.profile}
                  handleChange={this.handleChange}
                  submitUpdate={this.submitUpdate}
                  permissions={this.props.permissions}
                  toggles={this.props.toggles}
                />
              </Grid.Column>
              <Grid.Column width={9}>
                {!isOnlyProgramExternal(this.props.permissions) && (
                  <UserOrganizationRolesList
                    jwt={this.props.jwt}
                    permissions={this.props.permissions}
                    toggles={this.props.toggles}
                  />
                )}
              </Grid.Column>
            </Grid>
          </Container>
        </Main>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    profile: state.profile,
    userId: state.auth.userId,
    jwt: state.auth.token,
    permissions: state.auth.permissions,
    toggles: state.toggles.toggles,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getUser: (userId) => {
      const action = ApiActions.profile.getUser(userId);
      const response = dispatch(action);
      return response;
    },
    patchUser: (userId, payload, jwt) => {
      const action = ApiActions.profile.patchUser(userId, payload, jwt);
      const response = dispatch(action);
      return response;
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileContainer);
